import React, { Component } from "react";
import { connect } from "react-redux";
import * as dataActions from "../../../../../../_actions/dataActions";
import Wrapper from "../../../../../../_hoc/Wrapper";
import PageSubTitle from "../../../../../UI/PageSubTitle";
import EditWidget from "../../../../../UI/EditWidget";
import Select from "../../../../../UI/Select";
import getDiet from "../../../../../../_selectors/dataSelectors/getDiet";
import getHabitType from "../../../../../../_selectors/dataSelectors/getHabitType";

class HabitDetail extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.userProfile) {
      const { diet, smoke, drink } = nextProps.userProfile;
      const {
        isEditModeOn,
        selectedDiet,
        selectedDrink,
        selectedSmoke
      } = prevState;
      if (isEditModeOn) {
        return null;
      } else {
        if (
          diet !== selectedDiet ||
          smoke !== selectedSmoke ||
          drink !== selectedDrink
        ) {
          return {
            selectedDiet: diet,
            selectedDrink: drink,
            selectedSmoke: smoke
          };
        } else {
          return null;
        }
      }
    } else {
      return null;
    }
  }
  state = {
    isEditModeOn: false,
    showEdit: this.props.showEdit,
    selectedDiet: null,
    selectedSmoke: null,
    selectedDrink: null
  };
  componentDidMount() {
    const { diet, habitType, getDietData, getHabitTypeData } = this.props;
    if (diet.length === 0) {
      getDietData();
    }
    if (habitType.length === 0) {
      getHabitTypeData();
    }
  }
  disableEditMode = () => {
    this.setState({ isEditModeOn: false });
  };
  enableEditMode = () => {
    this.setState({ isEditModeOn: true });
  };
  save = () => {
    const { selectedDiet, selectedDrink, selectedSmoke } = this.state;
    const { update, toast } = this.props;
    const updatedHabitDetail = {
      diet: selectedDiet,
      drink: selectedDrink,
      smoke: selectedSmoke
    };
    const onSuccess = () => {
      this.setState({ isEditModeOn: false });
      toast({ type: "info", message: "Profile Updated" });
    };
    const onError = err => {
      toast({ type: "error", message: err });
    };
    update({ data: updatedHabitDetail, onSuccess, onError });
  };
  render() {
    const {
      isEditModeOn,
      selectedDiet,
      selectedDrink,
      selectedSmoke,
      showEdit
    } = this.state;
    const { diet, habitType, userProfile } = this.props;
    return (
      <Wrapper>
        <PageSubTitle>
          <h3>
            Habit Detail
            <EditWidget
              edit={isEditModeOn}
              onEdit={this.enableEditMode}
              onSave={this.save}
              onCancel={this.disableEditMode}
              disabled={userProfile.cache}
              show={showEdit}
            />
          </h3>
          <p />
        </PageSubTitle>
        <div className="form-group-one-unit">
          <div className="row">
            <div className="col-md-4">
              <Select
                label={<Wrapper>Diet</Wrapper>}
                selected={selectedDiet}
                options={diet}
                onChange={value => {
                  this.setState({ selectedDiet: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="-"
                readOnly={!isEditModeOn}
              />
            </div>
            <div className="col-md-4">
              <Select
                label={<Wrapper>Smoke</Wrapper>}
                selected={selectedSmoke}
                options={habitType}
                onChange={value => {
                  this.setState({ selectedSmoke: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="-"
                readOnly={!isEditModeOn}
              />
            </div>
            <div className="col-md-4">
              <Select
                label={<Wrapper>Drink</Wrapper>}
                selected={selectedDrink}
                options={habitType}
                onChange={value => {
                  this.setState({ selectedDrink: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="-"
                readOnly={!isEditModeOn}
              />
            </div>
          </div>
        </div>
      </Wrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  diet: getDiet(state),
  habitType: getHabitType(state)
});
const mapDispatchToProps = dispatch => ({
  getDietData: () => dispatch(dataActions.getDiet()),
  getHabitTypeData: () => dispatch(dataActions.getHabitType())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HabitDetail);



// WEBPACK FOOTER //
// ./src/_components/Profile/Home/ProfileInformation/Habit/HabitDetail/index.js